import styled from "styled-components";
import { Link } from "react-router-dom";

const color = "rgb(10, 144, 197)";
const bottomShadow = "rgb(39, 73, 87)";
const topShadow = "#1c1d1f";

export const PageWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const Container = styled.div`
  width: 100%;
  height: auto;
  min-height: 100vh;
  background-color: #03151f;
  position: static;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  overflow-y: visible;
  padding-bottom: 50px;
`;

export const AuthBackground = styled.div`
  position: fixed;
  top: -50%;
  left: -50%;
  width: 100vw;
  height: 100vh;
  background: radial-gradient(
    circle,
    rgba(24, 67, 89, 1) 0%,
    rgba(3, 21, 31, 1) 40%
  );
  z-index: -1;
`;

export const SubContainer = styled.div`
  box-sizing: border-box;
  height: ${(props) => props.height + "px"};
  width: 100%; /* Changed from fixed width to 100% */
  font-family: Arial;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  background: #2b2c2e;
  border-radius: 40px;
  box-shadow: 13px 13px 20px ${topShadow}, -13px -13px 20px ${bottomShadow};
  position: relative;
  padding: 20px;
  margin: 0; /* Removed margins since it's now controlled by parent container */
  overflow: hidden;

  /* Use transform for the slideUp animation */
  transform: ${(props) =>
    props.slideUp ? "translateY(-150%)" : "translateY(0)"};
  transition: transform 750ms cubic-bezier(0.68, -0.55, 0.265, 1.55),
    height 0.2s;
`;

export const Logo = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  border-top-left-radius: 40px;
  border-top-right-radius: 40px;
`;

export const LandingContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin-bottom: 50px;
  /* Add this to ensure the landing container is visible when auth form slides up */
  margin-top: ${(props) => (props.authSlideUp ? "-500px" : "0")};
  transition: margin-top 750ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
`;

// Divider between auth form and landing page
export const ContentDivider = styled.div`
  width: 100%;
  height: 30px;
`;

const AuthMessageBox = styled.div`
  box-sizing: border-box;
  height: 105px;
  margin: 30px 10px;
  box-sizing: border-box;
  background: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 25px;
  width: 100%;
  font-size: 14px;
  padding: 10px 20px;
  color: #d64958;
`;

export const ConfirmChangeContainer = styled(AuthMessageBox)`
  text-align: center;
  box-shadow: inset 8px 8px 8px ${topShadow},
    inset -8px -8px 8px ${bottomShadow};
  color: ${color};
  height: 75px;
`;

export const AuthErrorBox = styled(AuthMessageBox)`
  align-items: flex-start;
  box-shadow: inset 8px 8px 8px ${topShadow},
    inset -8px -8px 8px ${(props) => (props.pass ? "#30493b" : "#493033")};
`;

export const WelcomeBox = styled(AuthMessageBox)`
  box-sizing: border-box;
  box-shadow: inset 8px 8px 8px ${topShadow},
    inset -8px -8px 8px ${bottomShadow};
  color: ${color};
  font-weight: 500;
  height: 160px;
  padding: 30px;
`;

export const StyledLink = styled(Link)`
  color: ${color};
  cursor: pointer;
  font-size: 14px;
`;

export const ForgotPasswordHeader = styled.div`
  width: 100%;
  text-align: center;
  color: ${color};
  margin-bottom: 30px;
`;

export const AuthForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Field = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 25px;
`;

export const InputField = styled(Field)`
  box-sizing: border-box;
  margin-bottom: 25px;
  padding: 15px 10px 15px 5px;
  box-shadow: inset 8px 8px 8px ${topShadow},
    inset -8px -8px 8px ${bottomShadow};
`;

export const AuthInput = styled.input`
  border: none;
  outline: none;
  background-color: transparent !important;
  box-sizing: border-box;
  width: 100%;
  height: 34px;
  font-weight: 600;
  color: ${color};
`;

export const AuthButton = styled.button`
  box-sizing: border-box;
  border-radius: 20px;
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 6px 12px;
  background-color: ${(props) => (props.disabled ? "#536a7e" : color)};
  border: none;
  outline: none;
  height: 50px;
  width: 100%;
  color: white;
  font-size: 14px;
  font-weight: bold;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  box-shadow: 5px 5px 5px ${topShadow}, -5px -5px 5px ${bottomShadow};
`;
export const AuthRedirectText = styled.div`
  color: ${color};
  font-size: 14px;
  margin-right: 10px;
`;
export const AuthCheck = styled.div`
  color: ${(props) => (props.success ? "#19bf00" : "#df3312")};
  font-size: 14px;
`;

export const styleLoginIcon = (Component) => {
  return styled(Component)`
    margin: 0 10px;
    color: ${color};
  `;
};

export const SpinnerContainer = styled.div`
  align-items: center;
  display: flex;
  padding: 80px;
  justify-content: center;
`;
